import { DEFAULT_GLA_ID } from "../../../../../hooks/useGLAccounts.ts";
import {Transaction} from "../../TransactionsTable.tsx";

export enum FilterOperation {
    EQUALS,
    NOT_EQUALS,
    GREATER_THAN,
    LESS_THAN,
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
    ENDS_WITH,
    BETWEEN,
    NOT_BETWEEN,
}

export class Filter {
    id: string
    operation: FilterOperation
    columnId: string
    values: Array<any>
}

export class FilterService {

    constructor(
        readonly to_filter: Array<Transaction>,
    ) {
    }

    private parseDate(dateStr: string): Date {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(Date.UTC(year, month - 1, day));
    }

    private isDateBetween(date: Date, startDate: Date, endDate: Date): boolean {
        const start = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
        const end = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate(), 23, 59, 59));
        const checkDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        
        return checkDate >= start && checkDate <= end;
    }

    public apply(filters: Array<Filter>) {
        let filteredItems = this.to_filter;

        for (const filter of filters) {
            console.log('Running filtering for ', filter)

            if (filter.operation === FilterOperation.BETWEEN) {
                if (filter.columnId === 'bookingDate') {
                    const startDate = this.parseDate(filter.values[0]);
                    const endDate = this.parseDate(filter.values[1]);
                    
                    filteredItems = filteredItems.filter(item => {
                        const itemDate = this.parseDate(item.bookingDate);
                        return this.isDateBetween(itemDate, startDate, endDate);
                    });
                } else {
                    filteredItems = filteredItems.filter(
                        (item) => item[filter.columnId] >= filter.values[0] && item[filter.columnId] <= filter.values[1]
                    );
                }
            }

            if (filter.operation === FilterOperation.EQUALS) {
                const selectedValue = filter.values[0];

                if (filter.columnId === 'generalLedgerAccountId') {
                    filteredItems = filteredItems.filter(
                        (item) => {
                            const glaId = item.generalLedgerAccount.id;
                            if (selectedValue === DEFAULT_GLA_ID) {
                                return glaId === DEFAULT_GLA_ID;
                            }
                            return glaId === selectedValue;
                        }
                    );
                } else if (filter.columnId === 'category') {
                    filteredItems = filteredItems.filter(
                        (item) => item.generalLedgerAccount.cashflow_subcategory_nl === selectedValue
                    );
                } else {
                    filteredItems = filteredItems.filter(
                        (item) => item[filter.columnId as keyof Transaction] === selectedValue
                    );
                }
            }

            if (filter.operation === FilterOperation.GREATER_THAN) {
                filteredItems = filteredItems.filter(
                    (item) => {
                        if (filter.columnId === 'amount') {
                            return Math.abs(item.amount) > filter.values[0];
                        }
                        return item[filter.columnId] > filter.values[0];
                    }
                );
            }

            if (filter.operation === FilterOperation.LESS_THAN) {
                filteredItems = filteredItems.filter(
                    (item) => {
                        if (filter.columnId === 'amount') {
                            return Math.abs(item.amount) < filter.values[0];
                        }
                        return item[filter.columnId] < filter.values[0];
                    }
                );
            }

            if (filter.operation === FilterOperation.CONTAINS) {
                filteredItems = filteredItems.filter(
                    (item) => {
                        const value = String(item[filter.columnId]).toLowerCase();
                        const searchValue = String(filter.values[0]).toLowerCase();
                        return value.includes(searchValue);
                    }
                );
            }
        }

        return filteredItems
    }
}
